<template>
    <div>
        <model-filter @filtered = " (val) => extraFilters = {...extraFilters, ...val }"></model-filter>
        <elements-layout
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'
          :delete-data-url='deleteDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'userobjectpermission')"

          :useDefaultActions="[ $can('delete', 'userobjectpermission') ? 'delete': null]"
          idKey="id"
          :searchFieldActive="false"
          :extraFilters="extraFilters"
  >

    <template #addDataForm>
      <object-add-update></object-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">
        <template v-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>
            <template v-else>
                {{cell.value}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'permission'">
            <template v-if="get(cell.value, 'id')">
                <permission-cell :permission="cell.value"></permission-cell>
            </template>
            <template v-else>
                {{cell.value}}
            </template>
        </template>
    </template>

  </elements-layout>
    </div>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from './objectStoreModule'
  import useObject from './useObject'

  import ObjectAddUpdate from './objectAddUpdate/ObjectAddUpdate'
  import UserCell from "../../user/components/UserCell";
  import PermissionCell from "../../permission/components/PermissionCell";


  import get from 'lodash.get'
  import ModelFilter from "../model/components/ModelFilter";

  export default {
      components: {
          ModelFilter,
          PermissionCell,
          UserCell,
          ElementsLayout,
          ObjectAddUpdate,
      },

      setup() {

          const {

              fetchDataUrl,
              deleteDataUrl,
              tableColumns,
              extraFilters

          } = useObject();


          return {
              fetchDataUrl,
              deleteDataUrl,
              tableColumns,
              extraFilters,

              STORE_MODULE_NAME,
              STORE_MODULE_CONFIG,

              get

          }
    },
  }
</script>
